"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Test() {
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h3"
  }, "This is a test shared component");
}
var _default = exports["default"] = Test;